import React from 'react';
import { BenefitsSection } from './components/BenefitsSection';
import { BonusOffer } from './components/BonusOffer';
import { FinalCta } from './components/FinalCta';
import { Hero } from './components/Hero';
import { MetaPixel } from './components/MetaPixel';
import { ProblemSection } from './components/ProblemSection';
import { ProductDetails } from './components/ProductDetails';
import { SocialProof } from './components/SocialProof';
import { TopBar } from './components/TopBar';
import { Transformation } from './components/Transformation';
import { CountrySelector } from './components/currency/CountrySelector';
import { CurrencyProvider } from './components/currency/CurrencyContext';
export function App() {
  return <CurrencyProvider data-id="element-0" data-mp="2wj8cxn0bok3n">
      <div className="min-h-screen w-full overflow-x-hidden bg-[#fffaf0] text-[#143827]" data-id="element-1" data-mp="2wip7h5ruzo6i">
        <MetaPixel data-id="element-2" data-mp="28suv0pbgc1ms" />
        <CountrySelector data-id="element-3" data-mp="28sbe9bxjfjac" />
        <TopBar data-id="element-4" data-mp="23vktwcepa1j4" />
        <main data-id="element-5" data-mp="23w4ey1znd61d">
          <Hero data-id="element-6" data-mp="23ujjma5idj2g" />
          <ProblemSection data-id="element-7" data-mp="23v2s7099qv3t" />
          <Transformation data-id="element-8" data-mp="3ijxpqrsp22kf" />
          <BenefitsSection data-id="element-9" data-mp="3ikr002qv3a7b" />
          <ProductDetails data-id="element-10" data-mp="3ijfwm41bw4gq" />
          <BonusOffer data-id="element-11" data-mp="3ihuyy5jpw5en" />
          <SocialProof data-id="element-12" data-mp="3mlaxx8j9ehui" />
          <FinalCta data-id="element-13" data-mp="3mkhlps1j704z" />
        </main>
        <footer className="bg-[#0d291c] px-5 py-7 text-center text-sm text-[#b7cfbb] sm:px-8" data-id="element-14" data-mp="3mjq45l4rr2xp">
          <p className="font-display text-lg font-black tracking-tight text-[#fffaf0]" data-id="element-15" data-mp="3rd19tixuhdo1">
            Meal Prep Club
          </p>
          <p className="mt-2" data-id="element-16" data-mp="2zl3bdjx5744s">
            Tu método práctico para comer bien toda la semana.
          </p>
        </footer>
      </div>
    </CurrencyProvider>;
}